import axios from 'axios'
import {asResponse} from '../util'

export const TASKS_SWR_KEY = ({parentIds}) => [
  '/bff/tasks?status=PENDING',
  parentIds
]

export const getTasks = async (url, parentIds) => {
  let pendingIdsParam = parentIds.length ? `&parentIds=${parentIds.join(',')}` : ''
  if (pendingIdsParam.endsWith(',')) {
    pendingIdsParam = pendingIdsParam.substring(0, pendingIdsParam.length - 1)
  }
  url = `/bff/tasks?status=PENDING${pendingIdsParam}`
  const resp = await asResponse(axios.get(url))
  return {
    pendingTasks: resp.data.results
  }
}
